<template>
  <NewsCard :item="item" />
</template>

<script>
import { defineComponent } from "vue";
import NewsCard from "@/components/NewsCard.vue";

export default defineComponent({
  components: { NewsCard },
  props: ['item']
})
</script>